import { AppConfig } from '../../configuration/app.config';
import { Observable } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { Injectable, Type } from '@angular/core';
//import { PatchA3facturaCrmObjectRequest } from '../../models/patchA3facturaCrmObjectRequest.model';
import { BaseModel } from '../../models/base/base.model';



/*
    Clase base con los métodos comunes para realizar las peticiones a la api rest
*/
@Injectable()
export class HttpClientBaseService {
  private baseUrl: string;
  private actionPath: string;
  private childActionPath: string;
  private hasParent: boolean;

  constructor(protected http: HttpClient, actionPath: string, childActionPath?: string, hasParent: boolean = false) {
    this.baseUrl = AppConfig.settings.apiServer.apiUrl;
    this.actionPath = actionPath;
    this.childActionPath = childActionPath;
    this.hasParent = hasParent;
  }

  // Devuelve todos los elementos del tipo T
  public getAll<T>(parentId?: any, params?: HttpParams): Observable<T> {
    return this.http.get<T>(this.getUrl(null, parentId),{params : params});
  }

  // Devuelve todos el elemento T que contenga el id que se pasa por parámetros
  public getSingle<T>(id: any, parentId?: any): Observable<T> {
    return this.http.get<T>(this.getUrl(id, parentId));
  }

  // Devuelve todos los elementos del tipo T según los parámetros indicados en el parámetro URL
  protected get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(url, {params : params});
  }

  protected getOctet(url: string): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/octet-stream');
    return this.http.get(url, {headers: headers, responseType: 'blob'});
  }

  protected getOctetByPost(url: string, body: any): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/octet-stream');
    return this.http.post(url, body, {headers: headers, responseType: 'blob'});
  }

  public add<T>(entity: T, parentId?: any): Observable<T> {
    return this.http.post<T>(this.getUrl(null, parentId), entity);
  }

  public update<T>(id: number|string, entity: T, parentId?: number|string): Observable<T> {
    return this.http.put<T>(this.getUrl(id, parentId), entity);
  }

  public createInstance<T>(type: new() => T): T {
    return new type();
  }

  public delete(id: string|number, parentId?: any): Observable<Object> {
    return this.http.delete(this.getUrl(id, parentId));
  }

  public deleteWithRowVersion(id: string, rowVersion: number, parentId?: any) {

    let params: HttpParams = new HttpParams();
    params = params.set('version', rowVersion.toString());

    return this.http.delete(this.getUrl(id, parentId), {params: params});
  }

  public getUrl(id?: any, parentId?: any) {
    if (this.hasParent) {
      return this.getUrlWithPathParams(parentId, id);
    } else {
      return `${this.getConcatUrl()}${id ? id : ''}`;
    }
  }

  protected getConcatUrl(): string {
    return `${this.baseUrl}${this.actionPath}/`.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
  }

  protected getUrlWithPathParams(parentId: any, id?: any): string {
    return id
      ? `${this.getConcatUrl()}${parentId}/${this.childActionPath}/${id}`.replace(/(https?:\/\/)|(\/)+/g, '$1$2')
      : `${this.getConcatUrl()}${parentId}/${this.childActionPath}`.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }
}
